import {EventEmitter, Injectable} from '@angular/core';


@Injectable()
export class CardService {

  portals: any = {
    actions: undefined,
    footer: undefined
  };

  refresher: any = {
    visible: false,
    hidden: true,
    show() {
      this.visible = true;
      this.hidden = false;
    },
    hide() {
      this.visible = false;
      this.hidden = true;
    },
    updateChanges: new EventEmitter<void>(),
};

  constructor() { }

  setPortal(type: 'actions' | 'footer', template) {
    setTimeout(() => {
      this.portals[type] = template;
    });
  }

  clearPortal(type: 'actions' | 'footer') {
    setTimeout(() => {
      this.portals[type] = undefined;
    });
  }

  updateHook() {
    this.refresher.updateChanges.emit();
  }
}
